import { render } from "./ImportStudentsModal.vue?vue&type=template&id=df1c0e20"
import script from "./ImportStudentsModal.vue?vue&type=script&lang=js"
export * from "./ImportStudentsModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__